import gql from 'graphql-tag';

export const EDIT_BU_CONTACT = gql`
  mutation EditDataBUContact($buContact: BusinessContactBrandInput!) {
    editDataBusinessUnitContact(buContact: $buContact) {
      success
    }
  }
`;
